module.exports = "<!-- <ul> -->\n  <!-- <li><a routerLink=\"\">HBO GO LOGIN</a></li> -->\n<!-- </ul> -->\n<app-hbo></app-hbo>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main